class LoyaltyPopup extends HTMLElement {
  private dialog: HTMLDialogElement | null = null;
  private closeButtons: NodeListOf<HTMLElement> | null = null;
  private form: HTMLFormElement | null = null;
  private _triggerHandler: ((e: MouseEvent) => void) | null = null;
  private _outsideClickListener: ((e: MouseEvent) => void) | null = null;

  constructor() {
    super();
  }

  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    if (!this.dialog) return;

    this.closeButtons = this.querySelectorAll('[data-loyalty-popup-close]');
    this.form = this.querySelector('form');

    // Global document-level click listener for any custom manual triggers
    this._triggerHandler = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const trigger = target.closest('[data-open-loyalty-popup]');
      if (trigger) {
        e.preventDefault();
        this.open();
      }
    };
    document.addEventListener('click', this._triggerHandler);

    // Global click listener to close when clicking outside the dialog content
    this._outsideClickListener = (event: MouseEvent) => {
      if (!this.dialog || !this.dialog.open) return;
      const target = event.target as HTMLElement;
      // If the click is inside the loyalty-popup custom element itself, or on a trigger button, don't close
      if (this.contains(target) || target.closest('[data-open-loyalty-popup]')) {
        return;
      }
      this.close();
    };
    document.addEventListener('click', this._outsideClickListener);

    // Close button click listeners
    this.closeButtons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.close();
      });
    });

    // Close on dialog backdrop click (fallback for native modal backdrop clicks)
    this.dialog.addEventListener('click', (event) => {
      if (!this.dialog) return;
      const rect = this.dialog.getBoundingClientRect();
      const isInDialog = (
        rect.top <= event.clientY &&
        event.clientY <= rect.top + rect.height &&
        rect.left <= event.clientX &&
        event.clientX <= rect.left + rect.width
      );
      if (!isInDialog) {
        this.close();
      }
    });

    // Handle form submit loading state
    if (this.form) {
      this.form.addEventListener('submit', () => {
        const submitBtn = this.form?.querySelector('[type="submit"]') as HTMLButtonElement | null;
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.innerText = 'Subscribing...';
        }
      });
    }

    // Auto open on load (usually for success state message redirect check)
    if (this.getAttribute('data-open-on-load') === 'true') {
      setTimeout(() => {
        this.open();
        localStorage.setItem('loyalty-popup-dismissed', 'true');
      }, 400);
    }
  }

  disconnectedCallback() {
    if (this._triggerHandler) {
      document.removeEventListener('click', this._triggerHandler);
    }
    if (this._outsideClickListener) {
      document.removeEventListener('click', this._outsideClickListener);
    }
  }

  open() {
    if (this.dialog && !this.dialog.open) {
      this.dialog.show();
      document.body.classList.add('loyalty-popup-open');
    }
  }

  close() {
    if (this.dialog && this.dialog.open) {
      this.dialog.close();
      document.body.classList.remove('loyalty-popup-open');
      localStorage.setItem('loyalty-popup-dismissed', 'true');
    }
  }
}

export default LoyaltyPopup;
